import { Injectable } from "@angular/core";

import { Logger } from "./logger.service";

export let isDebugMode = true;

const noop = (): any => undefined;

@Injectable({
  providedIn: 'root'
})
export class ConsoleLoggerService implements Logger {
  get info() {
    if (isDebugMode) {
      // tslint:disable-next-line:no-console
      return console.info.bind(console);
    } else {
      return noop;
    }
  }

  get warn() {
    if (isDebugMode) {
      return console.warn.bind(console);
    } else {
      return noop;
    }
  }

  get error() {
    if (isDebugMode) {
      return console.error.bind(console);
    } else {
      return noop;
    }
  }

  get debug() {
    if (isDebugMode) {
      // tslint:disable-next-line:no-console
      return console.debug.bind(console);
    } else {
      return noop;
    }
  }
}
